var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "import-hyperlinks-modal",
        title: _vm.bulkUpload
          ? `Import Hyperlinks (File ${_vm.currentFileIndex + 1} of ${
              _vm.bulkJsonFiles.length
            })`
          : "Import Hyperlinks",
        centered: "",
        size: "lg",
      },
      on: {
        ok: _vm.handleOk,
        hide: _vm.handleClose,
        shown: _vm.handleModalShown,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: { click: _vm.handleClose },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.handleOk } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.bulkUpload &&
                          _vm.currentFileIndex < _vm.bulkJsonFiles.length - 1
                          ? "Next File"
                          : "Import"
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isDraggingOver,
              expression: "isDraggingOver",
            },
          ],
          staticClass: "drag-overlay",
          attrs: { id: "drop-area" },
        },
        [
          _c("span", { staticClass: "drag-overlay-text" }, [
            _vm._v("Drag & drop files here"),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.bulkUpload
        ? _c(
            "b-progress",
            {
              staticClass: "mb-3",
              attrs: {
                value: _vm.currentFileIndex + 1,
                max: _vm.bulkJsonFiles.length,
                "show-progress": "",
                height: "1rem",
              },
            },
            [
              _c(
                "b-progress-bar",
                {
                  attrs: {
                    value: _vm.currentFileIndex + 1,
                    max: _vm.bulkJsonFiles.length,
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        Math.round(
                          ((_vm.currentFileIndex + 1) /
                            _vm.bulkJsonFiles.length) *
                            100
                        )
                      ) +
                      "%\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.bulkUpload
                      ? `Current JSON file (${_vm.file ? _vm.file.name : ""})`
                      : `Current JSON file (${_vm.file ? _vm.file.name : ""})`,
                  },
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      placeholder: "Choose JSON file or drop it here...",
                      "drop-placeholder": "Drop file here...",
                      accept: ".json",
                      disabled: _vm.bulkUpload,
                    },
                    on: { change: _vm.handleFileChange },
                    model: {
                      value: _vm.file,
                      callback: function ($$v) {
                        _vm.file = $$v
                      },
                      expression: "file",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Apply to template:" } },
                [
                  _c("b-form-select", {
                    attrs: {
                      options: _vm.templateOptions,
                      disabled: !_vm.file,
                    },
                    model: {
                      value: _vm.selectedTemplateId,
                      callback: function ($$v) {
                        _vm.selectedTemplateId = $$v
                      },
                      expression: "selectedTemplateId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [_c("b-table", { attrs: { items: _vm.hyperlinks } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }